import {
  UserRoundCheck,
  HeartHandshake,
  UserPlus,
  ShieldCheck,
  TrendingUp,
  Award,
} from "lucide-react";

const SERVICES = [
  {
    id: "kundenrueckgewinnung",
    icon: UserRoundCheck,
    title: "Kundenrückgewinnung",
    text: "Wir holen ehemalige und wechselbereite Kunden durch persönliche Ansprache zurück.",
  },
  {
    id: "bestandskundenpflege",
    icon: HeartHandshake,
    title: "Bestandskundenpflege",
    text: "Wir stärken die Bindung zu bestehenden Kunden durch direkten Kontakt vor Ort.",
  },
  {
    id: "neukundengewinnung",
    icon: UserPlus,
    title: "Neukundengewinnung",
    text: "Wir gewinnen neue Kunden in definierten Vertriebsgebieten – strukturiert und messbar.",
  },
  {
    id: "marktsicherung",
    icon: ShieldCheck,
    title: "Marktsicherung",
    text: "Wir unterstützen Versorger dabei, ihre regionale Marktposition zu schützen.",
  },
  {
    id: "marktanteilsgewinnung",
    icon: TrendingUp,
    title: "Marktanteilsgewinnung",
    text: "Wir helfen beim Aufbau neuer Marktanteile und bei der perspektivischen Grundversorgungsgewinnung.",
  },
  {
    id: "vertrieb-qualitaet",
    icon: Award,
    title: "Vertrieb mit Qualität",
    text: "Unsere Teams werden geschult, begleitet und kontinuierlich weiterentwickelt.",
  },
];

export default function Services() {
  return (
    <section
      id="leistungen"
      data-testid="services-section"
      className="relative py-20 md:py-32 bg-[#F9FAFB]"
    >
      <div className="max-w-7xl mx-auto px-5 md:px-8 lg:px-12">
        <div className="max-w-3xl mb-14 md:mb-20">
          <div className="text-xs uppercase tracking-[0.2em] font-semibold text-[#0A3B2C] mb-4">
            Unsere Leistungen
          </div>
          <h2
            className="text-3xl md:text-5xl font-bold tracking-tight leading-[1.1] text-[#0A3B2C]"
            style={{ fontFamily: "Outfit, sans-serif" }}
            data-testid="services-title"
          >
            Mehr Kunden. Mehr Nähe. <br className="hidden md:block" />
            Mehr regionale Stärke.
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {SERVICES.map((s, i) => {
            const Icon = s.icon;
            return (
              <div
                key={s.id}
                data-testid={`service-card-${s.id}`}
                className="group relative bg-white border border-[#E5E7EB] rounded-2xl p-7 md:p-8 shadow-sm hover:shadow-lg hover:border-[#0A3B2C]/30 hover:-translate-y-0.5 transition-all duration-300"
              >
                <div className="w-12 h-12 rounded-xl bg-[#F0F5F2] group-hover:bg-[#0A3B2C] flex items-center justify-center mb-5 transition-colors">
                  <Icon className="h-6 w-6 text-[#0A3B2C] group-hover:text-white transition-colors" />
                </div>
                <div className="flex items-baseline gap-2 mb-2">
                  <span className="text-xs font-mono text-gray-400">0{i + 1}</span>
                </div>
                <h3
                  className="text-xl font-semibold text-[#0A3B2C] mb-3"
                  style={{ fontFamily: "Outfit, sans-serif" }}
                >
                  {s.title}
                </h3>
                <p className="text-sm text-gray-600 leading-relaxed">{s.text}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
